<script>
  export let label;
  export let value;
  export let anchor;

  function scrollTo(anchor) {
    const element = document.querySelector(anchor);
    if (element) {
      const offset = 100;
      const y = element.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({
        top: y,
        behavior: 'smooth'
      });
    }
  }

</script>

<div class="subscriptions-summary-properties-item">
  <a href="javascript:void(0)" title="Edit" on:click|preventDefault={() => scrollTo(`#${anchor}`)}>
    <h3>{label}</h3>
    {#if value}
      <p>{value}</p>
    {:else}
      <p class="is-empty">Choose a selection</p>
    {/if}
  </a>
</div>
